"use client";

import { Loader2 } from "lucide-react";

interface LoadingPageProps {
  message?: string;
  fullScreen?: boolean;
}

export function LoadingPage({
  message = "Загрузка...",
  fullScreen = true,
}: Readonly<LoadingPageProps>) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-6 bg-background ${
        fullScreen ? "fixed inset-0" : "h-screen"
      }`}
    >
      <div className="relative">
        {/* Outer spinning ring */}
        <div className="absolute inset-0 animate-spin animation-duration-1500 rounded-full border-4 border-border border-t-accent" />

        {/* Middle spinning ring */}
        <div className="absolute inset-0 m-2 animate-spin animation-duration-2000 direction-reverse rounded-full border-4 border-border border-t-primary opacity-60" />

        {/* Inner icon */}
        <div className="flex size-20 items-center justify-center">
          <Loader2 className="size-8 animate-spin text-foreground" />
        </div>
      </div>

      {/* Loading text with fade animation */}
      <div className="flex flex-col items-center gap-2 animate-pulse">
        <p className="text-lg font-semibold text-foreground">{message}</p>
      </div>
    </div>
  );
}
